import PropTypes from 'prop-types';

import LandingPageImage from 'components/landing/LandingPageImage';

const InstagramPic = ({ index, imageDetails, shouldLazyLoad, onLandingComponentClick, className: parentClassName }) => {
  const { images, link, caption } = imageDetails || {};
  const { small } = images || {};
  const { text } = caption || {};
  const imageProps = { src: small, alt: text, title: text, role: 'listitem', shouldLazyLoad };
  return (
    <a
      className={parentClassName}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onLandingComponentClick}
      data-eventlabel="Instagram"
      data-eventvalue={`instagrampicture-${index}`}
    >
      <LandingPageImage {...imageProps} />
    </a>
  );
};

InstagramPic.propTypes = {
  imageDetails: PropTypes.object.isRequired,
  onLandingComponentClick: PropTypes.func.isRequired
};

export default InstagramPic;
